var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "js-suggest-item search-product",
      attrs: { href: _vm.url, "data-html": _vm.name },
      on: {
        click: function($event) {
          return _vm.$emit("clickHandler")
        }
      }
    },
    [
      _c("div", { staticClass: "search-product__image-block" }, [
        _c("img", {
          staticClass: "search-product__image-pic",
          attrs: { src: _vm.img, alt: "" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "search-product__container" }, [
        _c("span", {
          staticClass: "search-product__title",
          domProps: {
            innerHTML: _vm._s(
              _vm.getSearchCaption(_vm.name, _vm.query.trim().toLowerCase())
            )
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "search-product__price" }, [
          _c("div", { staticClass: "search-product__price-current" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm._f("priceFormatted")(_vm.price, "", true, false)) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _vm.price < _vm.priceBase
            ? _c("div", { staticClass: "search-product__price-old" }, [
                _c("div", { staticClass: "search-product__price-old-value" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("priceFormatted")(_vm.priceBase)) +
                      "\n        "
                  )
                ]),
                _vm._v(" "),
                _vm.percentDiscount !== null
                  ? _c(
                      "div",
                      { staticClass: "search-product__price-discount" },
                      [
                        _c("div", { staticClass: "discount _big" }, [
                          _vm._v(
                            "\n            -" +
                              _vm._s(_vm.percentDiscount) +
                              "%\n          "
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }